export const CONFIGURATOR_VALUE_UPDATE = 'CONFIGURATOR_VALUE_UPDATE';
export const SET_PRODUCTS = 'SET_PRODUCTS';
export const PRODUCT_VALUE_UPDATE = 'PRODUCT_VALUE_UPDATE';
export const SET_HANDBOOK_FILE = 'SET_HANDBOOK_FILE'
export const SHOW_MORE_PRODUCT_INFO_POPUP = 'SHOW_MORE_PRODUCT_INFO_POPUP';
export const SET_CONFIGURATOR_ID = 'SET_CONFIGURATOR_ID';
export const SET_PRE_CHECKOUT_TEXT = 'SET_PRE_CHECKOUT_TEXT';
export const CONFIGURATOR_VALUE_SHARE_UPDATE = 'CONFIGURATOR_VALUE_SHARE_UPDATE';
import { post } from "../../Services/http";
import { ConfiguratorConstants } from "../../Models/Configurator/ConfiguratorConstants";

export const UpdateConfiguratorValue = (name, value, calculate = false) => (dispatch, getState) => {        
    const { configuratorValues, products } = getState().productConfigurator.payload;
    let tempConfiguratorValues = configuratorValues;
    if (!tempConfiguratorValues.find(x => x.name === name)) {
        tempConfiguratorValues.push({name: name, value: value});
    } else {
        let item = tempConfiguratorValues.find(x => x.name === name);
        item.value = value;
        const indexOfCurrentItem = tempConfiguratorValues.findIndex(x => x.name === name);
        tempConfiguratorValues.splice(indexOfCurrentItem + 1, tempConfiguratorValues.length);
        dispatch(setCalculatedProducts(products.map(x => {
            return {...x, calculatedQuantity: 0, confirmedQuantity: 0}
        })));
    }    
    dispatch(setConfiguratorValues(tempConfiguratorValues));    

    if (calculate) {             
        var cookieValue = encodeURI(JSON.stringify(tempConfiguratorValues));
        const now = new Date();
        now.setDate(now.getDate() + 1);
        const expires = "expires=" + now.toUTCString() + ";";

        document.cookie = ConfiguratorConstants.WallConfiguratorCookie + "=" + cookieValue;
        document.cookie = expires;
        dispatch(calculateQuantity(dispatch, getState));
    }
}

export const setConfiguratorValues = (data) => ({
    type: CONFIGURATOR_VALUE_UPDATE,
    payload: data
});

export const calculateQuantity = (dispatch, getState) => {    
    const { configuratorValues, products } = getState().productConfigurator.payload;
    post('api/productconfigurator/calculatequantity', {
        products: products,
        configuratorValues : configuratorValues
    })
    .then(response => response.json())
    .then(result => {
        dispatch(setCalculatedProducts(result.products));
        dispatch(setHandbookFile(result.handBookFile));
        dispatch(setPreCheckoutText(result.preCheckoutText));
        dispatch(setConfiguratorId(result.configuratorId));
    })
}

export const setCalculatedProducts = (products) => ({
    type: SET_PRODUCTS,
    payload: products
});

export const setHandbookFile = (handBookFile) => ({
    type: SET_HANDBOOK_FILE,
    payload: handBookFile
});

export const setPreCheckoutText = (preCheckoutText) => ({
    type: SET_PRE_CHECKOUT_TEXT,
    payload: preCheckoutText
});

export const setConfiguratorId = (configuratorId) => ({
    type: SET_CONFIGURATOR_ID,
    payload: configuratorId
});

export const updateProductValue = (articleNumber, newQuantity) => ({
    type: PRODUCT_VALUE_UPDATE,
    payload: { articleNumber, newQuantity }
});

export const showConfiguratorMoreProductInfoPopUp = (productUrl) => ({
    type: SHOW_MORE_PRODUCT_INFO_POPUP,
    payload: {
        showConfiguratorMoreProductInfoPopUp: true,
        productUrl
    }
})

export const hideConfiguratorMoreProductInfoPopUp = () => ({
    type: SHOW_MORE_PRODUCT_INFO_POPUP,
    payload: {
        showConfiguratorMoreProductInfoPopUp: false,
    }
});

export const setConfiguratorModuleShareData = (moduleShareData) => ({
    type: CONFIGURATOR_VALUE_SHARE_UPDATE,
    payload: moduleShareData
});